import AuthorizationForms from './AuthorizationForms';

export default AuthorizationForms;
